export default __webpack_public_path__ + "static/media/bin-day-calendars.53d103fe.svg";